'use es6';

import getErrorTypeFromException from 'reporting-data/lib/getErrorTypeFromException';
import { RaiseError } from '../../../../trap/ErrorTrap';

/**
 * TODO: Remove all of raise error and simplify it...
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ReportErrored = ({
  error,
  isMobile
}) => /*#__PURE__*/_jsx("div", {
  className: "report-status-error reporting-visualization-report",
  "data-status-id": "report-status-error",
  "data-test-id": "reporting-visualization-report",
  children: /*#__PURE__*/_jsx(RaiseError, {
    type: getErrorTypeFromException(error),
    error: error,
    isMobile: isMobile
  })
});
export default ReportErrored;